"use strict";import{MenuDivider as e}from"./src/MenuDivider.js";import{defineElement as i}from"@spectrum-web-components/base/src/define-element.js";i("sp-menu-divider",e);
//# sourceMappingURL=sp-menu-divider.js.map
